module.exports = __webpack_public_path__ + "media/images/city_img/m_bg-1f2a301dda4291ce189d9ffb3c25d3f9.jpg";